// First-load settings dialog. Stores API URL + key + tenant_id in
// localStorage so the bundle itself contains no secrets - disposable UI
// can ship to a public S3+CF without leaking the key.

import { useState } from "react";
import type { ApiConfig } from "../api";

export function ConfigPanel({
  initial,
  onSave,
}: {
  initial: ApiConfig | null;
  onSave: (cfg: ApiConfig) => void;
}) {
  const [baseUrl, setBaseUrl] = useState(initial?.baseUrl ?? "");
  const [apiKey, setApiKey] = useState(initial?.apiKey ?? "");
  const [tenantId, setTenantId] = useState(initial?.tenantId ?? "apeak");

  const valid = baseUrl.startsWith("https://") && apiKey.length > 0 && tenantId.length > 0;

  return (
    <div className="config-screen">
      <div className="config-card">
        <h1>Tenant Admin API · Test UI</h1>
        <p className="config-subtitle">
          Disposable harness for the Logs endpoint. Settings stay in this
          browser's localStorage; the key never leaves your machine.
        </p>

        <label>
          API base URL
          <input
            value={baseUrl}
            onChange={(e) => setBaseUrl(e.target.value)}
            placeholder="https://abc123.execute-api.us-east-1.amazonaws.com"
            spellCheck={false}
          />
        </label>

        <label>
          X-Api-Key
          <input
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            placeholder="paste from Secrets Manager"
            type="password"
            spellCheck={false}
          />
        </label>

        <label>
          Tenant ID
          <input
            value={tenantId}
            onChange={(e) => setTenantId(e.target.value)}
            placeholder="apeak"
            spellCheck={false}
          />
        </label>

        <button
          className="primary"
          disabled={!valid}
          onClick={() => onSave({ baseUrl: baseUrl.trim(), apiKey: apiKey.trim(), tenantId: tenantId.trim() })}
        >
          Connect
        </button>
      </div>
    </div>
  );
}
